import React from 'react'
import { AiOutlineCheckCircle } from 'react-icons/ai'


const Information = ({message}) => {
    return (
        <div className="information">
            <AiOutlineCheckCircle size="35"/>
            <div className="information__message">{message}</div>
        </div>
    );
}

export default Information;
